import React, { useEffect } from 'react';

import { Container } from '@mui/material';

import { angularizeWithProviders } from '../../../shared/providers';

import {
  useVideosManagement,
  VideosManagementProvider,
} from './hooks/useVideosManagement';
import { AddVideoPageTitle } from './AddVideoPageTitle/AddVideoPageTitle';
import { VideosTable } from './VideosTable/VideosTable';

const NgzVideosManagement = () => {
  const videosManagement = useVideosManagement();

  useEffect(() => {
    videosManagement.getVideos();
  }, []);

  return (
    <Container>
      <VideosManagementProvider value={videosManagement}>
        <AddVideoPageTitle />
        <VideosTable />
      </VideosManagementProvider>
    </Container>
  );
};

angularizeWithProviders(NgzVideosManagement, 'ngzVideosManagement', {});

export { NgzVideosManagement };
